export default {
    item: {
        username: 'Username',
        password: 'Password',
        email: 'Email',
    },

    userForm: {
        title: 'ROLE CONSULTING',
        id: 'Please enter the role Id',
        idEmptyRemind: 'Role Id cannot be empty',
        idErrorRemind: 'Role Id must be a numeric value',
        email: 'Please enter email',
        emailEmptyRemind: 'Please input the email address',
        emailErrorRemind: 'Please input the correct email address',
        required: 'Required: Please fill in the correct email address (email name is not less than 4 characters) in order to accept the consumption voucher of this order.',
    },
    confirm: 'CONFIRM',
    cancel: "CANCEL",
    shop: {
        name: 'Commodity',
        detail: 'Product Detail',
        little0: ' Gift Packs',
        little1: 'Voucher',
    },
    info: 'detail',

    order: {
        summary: 'INFO',
        id: 'role id',
        nikeName: 'nick name',
        email: 'email',
        productName: 'product',
        paymentAmount: 'amount',
        payWarn: "Reminder: In order to shorten the delivery time of the goods, it is recommended ",
        payObvious: "to restart the game software after successful payment",
    },

    jsHint: {
        role:{
            notExist: "No information about this role！！！",
            infoError: "Character information entered incorrectly！！！",
            input: "Please enter character information first！！！",
        },
        shop: {
            choose: "Please select an item！！！",
            limit: "This product has reached the purchase limit, please select again！！！",
        },
        order: {
            fail: "Failed to create order, please contact customer service！！！" ,
        },
    },

    channel: {
        title: "Payment Channel",
        EN: "English area",
        TW: "Traditional Chinese area",
        CN: "Simplified Chinese area",
        SCN: "Simplified Chinese(Southeast area)",
        warn: "Please select your location so that we can provide payment method.",
    },
}